import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export interface PageBreadcrumbsProps {
  className?: string;
}

function PageBreadcrumbsRoot({ children, className }: React.PropsWithChildren<PageBreadcrumbsProps>) {
  return <ol className={classNames('flex list-none m-0 p-0 items-center flex-wrap')}>{children}</ol>;
}

export interface PageBreadcrumbsLinkProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

export function PageBreadcrumbsLink({
  children,
  className,
  onClick,
}: React.PropsWithChildren<PageBreadcrumbsLinkProps>) {
  return (
    <li
      className={classNames(
        'flex items-center flex-nowrap whitespace-nowrap',
        `after:content-['/']`,
        'after:flex after:mx-2 after:text-sm after:self-center after:leading-none after:-mt-[3px] after:whitespace-nowrap after:text-[#8B827A] after:dark:text-[#8B827A] after:font-regular',
        'last-of-type:after:content-none',
        className,
      )}
    >
      <button
        onClick={onClick}
        disabled={typeof onClick !== 'function'}
        className={classNames(
          'inline-flex font-semibold uppercase rounded leading-normal text-xs tracking-wide',
          'text-brand-primary hover:text-brand-primary dark:text-brand-primary dark:hover:text-brand-primary hover:underline disabled:no-underline disabled:text-[#8B827A] disabled:dark:text-secondary',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 dark:focus-visible:ring-offset-gray-800',
        )}
      >
        {children}
      </button>
    </li>
  );
}

export const PageBreadcrumbs = Object.assign(PageBreadcrumbsRoot, { Link: PageBreadcrumbsLink });

export default PageBreadcrumbs;
